export default '/static/frontend/ReachDigital/12gobiking/dist/assets/bankcontant-fb42979b.svg'